import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardContent, Typography } from "@mui/material";

export default function CardItem({ img, title, color, onClick }){
    return (
        <Card
            onClick={onClick}
            sx={{
                height: '80px',
                padding: '10px',
                borderRadius: '8px',
                backgroundColor: 'grey.200',
                boxShadow: 'none',
                cursor: 'pointer',
                transition: 'border-color 0.3s ease, background-color 0.3s ease',
                '&:hover': {
                    borderColor: color,
                    backgroundColor: 'grey.100',
                },
            }} 
        >
            <CardContent 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <FontAwesomeIcon icon={img} color={color}/>

                <Typography sx={{
                    mt: 1,
                    textAlign: 'center',
                    fontSize: '12px',
                    fontFamily: '"Poppins", sans-serif',
                    color: '#333333',
                    fontWeight: 'bold'
                }}
                >
                    {title}
                </Typography>
            </CardContent>
        </Card>
    );
};